import MyCertificates from "components/partial/myDesk/my-certificates/my-certificates";
import { useRouteUserId } from "hooks/useRouteUserId";
import MyAccountLayout from "layouts/my-account/my-account-layout";
import ProfileLayout from "layouts/private/profile/profile-layout";

const MyCertificatesPage = () => {
	const { routeUserId } = useRouteUserId();
	return routeUserId ? (
		<ProfileLayout>
			<MyCertificates />
		</ProfileLayout>
	) : (
		<MyAccountLayout>
			<MyCertificates />
		</MyAccountLayout>
	);
};

export default MyCertificatesPage;
